import { Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  createAssemblyConstituency,
  updateAssemblyConstituency,
} from "../api/requests/assemblyConstituency";
import { useAlert } from "../context/AlertContext";
import { commonStrings } from "../static/commonStrings";
import { AssemblyConstituencyType, ZoneType } from "../utils/types";
import CommonDialog from "./common/CommonDialog";

const CreateOrEditAssemblyConstituency = ({
  setOpenCreateDialog,
  onSaveAssemblyConstituencyCB,
  isEdit = false,
  assemblyConstituencyData,
  selectedZone,
}: {
  setOpenCreateDialog: () => void;
  onSaveAssemblyConstituencyCB: () => void;
  isEdit?: boolean;
  assemblyConstituencyData?: AssemblyConstituencyType;
  selectedZone: ZoneType;
}) => {
  const [assemblyConstituency, setAssemblyConstituency] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedZoneId, setSelectedZoneId] = useState<string>("");
  const { showAlert } = useAlert();

  useEffect(() => {
    if (isEdit) {
      setAssemblyConstituency(
        assemblyConstituencyData?.assemblyConstituencyName || ""
      );
      setSelectedZoneId(
        assemblyConstituencyData?.zoneId
          ? String(assemblyConstituencyData.zoneId)
          : ""
      );
    } else {
      setSelectedZoneId(String(selectedZone.zoneId));
      setAssemblyConstituency("");
    }
  }, [isEdit, selectedZone]);

  const handleSaveAssemblyConstituency = async () => {
    const createAssemblyConstituencyRes = await createAssemblyConstituency({
      assemblyConstituencyName: assemblyConstituency!,
      zoneId: selectedZone.zoneId,
    });
    if (createAssemblyConstituencyRes.status == 200) {
      showAlert("Added successfully", "success");
    }
    onSaveAssemblyConstituencyCB();
  };

  const handleAssemblyConstituencyNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setAssemblyConstituency(event.target.value);
  };

  const handleEditAssemblyConstituency = async () => {
    if (assemblyConstituencyData) {
      const editAssemblyConstituencyRes = await updateAssemblyConstituency({
        assemblyConstituencyId:
          assemblyConstituencyData?.assemblyConstituencyId,
        assemblyConstituencyName: assemblyConstituency!,
        zoneId: Number(selectedZoneId)!,
      });
      if (editAssemblyConstituencyRes.status == 200) {
        showAlert("Edited successfully", "success");
      }
      onSaveAssemblyConstituencyCB();
    }
  };

  const dialogTitle = `${isEdit ? "Edit" : "Create"} ${
    commonStrings.sideBarMenuTitles.assemblyConstituency
  }`;

  const isFormValid = !!(selectedZoneId && assemblyConstituency?.trim());

  return (
    <CommonDialog
      title={dialogTitle}
      cancelButton={() => setOpenCreateDialog()}
      actionButtonTitle="Save"
      cancelButtonTitle="Cancel"
      actionButton={
        isEdit ? handleEditAssemblyConstituency : handleSaveAssemblyConstituency
      }
      disableActionButton={!isFormValid || loading}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 1 }}>
        <Box>
          <TextField
            fullWidth
            required
            label={`Enter ${commonStrings.sideBarMenuTitles.zone}`}
            value={selectedZone.zoneName}
            disabled
          />
        </Box>
        <Box>
          <TextField
            fullWidth
            required
            label={`Enter ${commonStrings.sideBarMenuTitles.assemblyConstituency}`}
            value={assemblyConstituency}
            onChange={handleAssemblyConstituencyNameChange}
            disabled={loading}
          />
        </Box>
      </Box>
    </CommonDialog>
  );
};

export default CreateOrEditAssemblyConstituency;
